<template>
  <v-app class="app">
    <main-header v-if="$route.meta?.header" @snackbar="showSnackbar($event)" />
    <v-main>
      <div
        v-if="environment.name == 'staging' && $route.name != 'login'"
        class="mt-8 pa-2 pt-10 red text-center white--text">
        HOMOLOGAÇÃO
      </div>

      <v-container :class="$route.meta?.header ? 'mt-12' : 'login'">
        <router-view @snackbar="showSnackbar($event)" />
      </v-container>
      <v-footer :class="$route.meta?.title == 'Login' ? 'pt-5' : 'pt-2'" dark padless>
        <v-card flat tile width="100%" class="pa-0" style="background: #252525">
          <v-card-text class="white--text text-center pe-2 py-0">
            <span class="align-center">
              Feito pela&nbsp;
              <img
                class="mx-1"
                src="@/assets/images/icons/favicon-16x16.png"
                alt="QuiteJá"
                style="position: relative; top: 3px;"
              />
              <strong>QuiteJá</strong> 
            </span>
            <span style="float: left;font-size: 10px;font-weight: 900">v{{ version }}</span>
          </v-card-text>
        </v-card>
      </v-footer>
    </v-main>
    
    <v-snackbar
      :top="snackbar.top"
      :left="snackbar.left"
      :text="snackbar.text"
      :right="snackbar.right"
      :color="snackbar.color"
      :bottom="snackbar.bottom"
      :timeout="snackbar.timeout"
      :vertical="snackbar.vertical"
      :centered="snackbar.centered"
      :multi-line="snackbar.multiLine"
      :transition="snackbar.transition"
      v-model="snackbar.show"
    >
      <div :style="snackbar.textStyle" v-html="snackbar.message"></div>
      <template v-slot:action="{ attrs }" v-if="snackbar.btn.show">
        <v-btn
          text
          v-bind="attrs"
          v-if="snackbar.btn.text"
          :color="snackbar.btn.color"
          @click="snackbar.btn.func(snackbar)"
        >
          {{ snackbar.btn.text }}
        </v-btn>
        <v-btn
          icon
          v-else
          v-bind="attrs"
          :color="snackbar.btn.color"
          @click="snackbar.btn.func(snackbar)"
        >
          <v-icon>{{ snackbar.btn.icon }}</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script lang="ts">
import { version } from "@/../package.json";
import { Vue, Component } from "vue-property-decorator";
import MainHeader from "./components/Header.vue";
import environment from "@/environment";


@Component({
  components: {
    "main-header": MainHeader,
  },
})
export default class App extends Vue {
  // Versão da aplicação
  version = version;
  environment = environment;

  snackbar = {
    top: false,
    show: false,
    text: false,
    left: false,
    bottom: true,
    right: false,
    absolute: true,
    outlined: false,
    centered: false,
    vertical: false,
    multiLine: false,
    timeout: 5000,
    color: "",
    message: "",
    textStyle: "",
    transition: "fade-transition",
    btn: {
      show: true,
      text: "",
      color: "yellow",
      icon: "mdi-close",
      func: function (config: any) {
        config.show = false;
      },
    },
  };

  showSnackbar(config: any = null) {
    this.snackbar = {
      top: false,
      show: false,
      text: false,
      left: false,
      bottom: true,
      right: false,
      absolute: true,
      outlined: false,
      centered: false,
      vertical: false,
      multiLine: false,
      timeout: 5000,
      color: "",
      message: "",
      textStyle: "",
      transition: "fade-transition",
      btn: {
        show: true,
        text: "",
        color: "yellow",
        icon: "mdi-close",
        func: function (config: any) {
          config.show = false;
        },
      },
    };
    if (config != null) {
      let btn = null;
      if (config.btn) {
        btn = Object.assign(this.snackbar.btn, config.btn);
      }
      this.snackbar = Object.assign(this.snackbar, config);
      if (btn) {
        this.snackbar.btn = btn;
      }
    }
    this.snackbar.show = true;
  }
}
</script>

<style lang="scss" scoped>
.theme--dark.v-footer {
    background-color: #252525;
    color: #FFFFFF;
}
.app {
  background-color: #252525 !important;

  .container {
    min-height: calc(100vh - 82px);
    @media (min-width: 1264px) {
      max-width: 1700px;
    }

    @media (min-width: 960px) {
      max-width: 1700px;
    }
  }
  
  .login {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: calc(100vh - 48px) !important;
  }

  .version {
    color: #ffffff;
    font-size: 12px;
    text-align: center;
  }
}
</style>
